import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const rootElement = document.getElementById("root");

// Use hydrateRoot if react-snap has pre-rendered real content (has element children, not just scripts)
const hasPrerenderedContent = Array.from(rootElement.children).some(
  child => child.tagName !== 'SCRIPT'
);

if (hasPrerenderedContent) {
  ReactDOM.hydrateRoot(
    rootElement,
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
} else {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}
